export const SET_MB_STORE = "SET_MB_STORE";
export const ADD_MB_TYPE = "ADD_MB_TYPE";
export const REMOVE_MB_TYPE = "REMOVE_MB_TYPE";
export const SET_MB_PATH_CUSTOM = "SET_MB_PATH_CUSTOM";
